export const desktopDownloadTranslations = {
  he: {
    title: 'Worki גם במחשב שלכם', download: 'הורדת האפליקציה למחשב', dismiss: 'הסתרת ההמלצה',
    hint: 'סריקה ישירות מהסורק אל המסמכים, החשבוניות או המסמך לחתימה — בדיוק מהמקום שבו התחלתם.',
    included: 'מנוע הסריקה כלול באפליקציה. התחברו עם חשבון Worki הקיים שלכם.',
    version: 'גרסה {{version}}', recommended: 'מתאים למחשב הזה', unavailable: 'ההורדות אינן זמינות כרגע. נסו שוב מאוחר יותר.',
    steps: 'מורידים ומתקינים, מתחברים לחשבון, ובוחרים ״סריקה מהסורק״ במקום שאליו רוצים להוסיף את המסמך.',
    drivers: 'הסורק צריך להיות מחובר ומוגדר במערכת. בלינוקס ייתכן שתידרש התקנת חבילות SANE; מתקין DEB מתקין את התלויות הנדרשות.',
    unsigned: 'גרסת Windows חתומה בתעודה עצמית. התעודה אינה מקנה אמון ציבורי של Windows, ולכן עדיין עשויה להופיע אזהרת מפתח לא מוכר.',
    verification: 'פרטי אימות ההורדה',
  },
  en: {
    title: 'Worki on your computer', download: 'Download desktop app', dismiss: 'Dismiss recommendation',
    hint: 'Scan directly into your documents, invoices or signing draft — right where you started.',
    included: 'The scanner engine is included. Sign in with your existing Worki account.',
    version: 'Version {{version}}', recommended: 'For this computer', unavailable: 'Downloads are unavailable right now. Please try again later.',
    steps: 'Download and install, sign in, then choose “Scan from scanner” where you want to add the document.',
    drivers: 'Connect and configure your scanner in the operating system. Linux may require SANE packages; the DEB installer declares the required dependencies.',
    unsigned: 'The Windows release uses a self-signed certificate. It does not provide public Windows trust, so an unknown publisher warning may still appear.',
    verification: 'Download verification details',
  },
};
